import { createSlice } from "@reduxjs/toolkit";
import { getUserList, saveUser, deleteUser } from "../controller/user.controller";
import { AdminUser } from "../types/userType";
import { SaveResponse } from "../types/common";

interface UserState {
  loading: boolean;
  list: AdminUser[];
  total: { pages: number; data: number };
  response: SaveResponse | null;
  error: string | null;
}

const initialState: UserState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  response: null,
  error: null,
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUserResponse: (state) => {
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUserList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getUserList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data pengguna";
      })
      .addCase(saveUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(saveUser.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;
      })
      .addCase(saveUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal menyimpan pengguna";
      })
      .addCase(deleteUser.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetUserResponse } = userSlice.actions;
export default userSlice.reducer;
